<div class="top-actions">  
  <a class="button fancy-button action-btn" (click)="printPage()">
    <i class="material-icons">print</i>Print
  </a>
  <a class="button fancy-button action-btn" (click)="viewResults()">
    <i class="material-icons">arrow_back</i>Back
  </a>
</div>
<div class="results-title"><h5>{{ nameDesc }}</h5></div>
<div class="table-container">
  <table class="table">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Joint Area</th>
          <th colspan="2" scope="col">Rating (% of 100)&NonBreakingSpace; &NonBreakingSpace;
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Neck</td>
          <td colspan="2" [class]="GetAreaClass(results.GetAreaState(Area.neck))">{{ results.GetAreaState(Area.neck) }}</td>
        </tr>
        <tr>
          <td>Upper Back</td>
          <td colspan="2" [class]="GetAreaClass(results.GetAreaState(Area.upperBack))">{{ results.GetAreaState(Area.upperBack) }}</td>
        </tr>
        <tr>
          <td>Lower Back</td>
          <td colspan="2" [class]="GetAreaClass(results.GetAreaState(Area.lowerBack))">{{ results.GetAreaState(Area.lowerBack) }}</td>
        </tr>
        <tr>
          <td>Below Lower Back (SI)</td>
          <td colspan="2" [class]="GetAreaClass(results.GetAreaState(Area.sacroiliac))">{{ results.GetAreaState(Area.sacroiliac) }}</td>
        </tr>
        <tr>
          <td>Shoulders</td>
          <td [class]="GetAreaClass(results.GetAreaState(Area.shoulderLeft))">Left {{ results.GetAreaState(Area.shoulderLeft) }}</td>  
          <td [class]="GetAreaClass(results.GetAreaState(Area.shoulderRight))">Right {{ results.GetAreaState(Area.shoulderRight) }}</td>     
        </tr>
        <tr>
          <td>Elbows</td>
          <td [class]="GetAreaClass(results.GetAreaState(Area.elbowLeft))">Left {{ results.GetAreaState(Area.elbowLeft) }}</td>  
          <td [class]="GetAreaClass(results.GetAreaState(Area.elbowRight))">Right {{ results.GetAreaState(Area.elbowRight) }}</td>     
        </tr>
        <tr>
          <td>Wrists</td>
          <td [class]="GetAreaClass(results.GetAreaState(Area.wristLeft))">Left {{ results.GetAreaState(Area.wristLeft) }}</td>  
          <td [class]="GetAreaClass(results.GetAreaState(Area.wristRight))">Right {{ results.GetAreaState(Area.wristRight) }}</td>     
        </tr>
        <tr>
          <td>Thumbs</td>
          <td [class]="GetAreaClass(results.GetAreaState(Area.thumbLeft))">Left {{ results.GetAreaState(Area.thumbLeft) }}</td>  
          <td [class]="GetAreaClass(results.GetAreaState(Area.thumbRight))">Right {{ results.GetAreaState(Area.thumbRight) }}</td>      
        </tr>
        <tr>
          <td>Fingers</td>
          <td [class]="GetAreaClass(results.GetAreaState(Area.fingersLeft))">Left {{ results.GetAreaState(Area.fingersLeft) }}</td>  
          <td [class]="GetAreaClass(results.GetAreaState(Area.fingersRight))">Right {{ results.GetAreaState(Area.fingersRight) }}</td>     
        </tr>
        <tr>
          <td>Hips</td>
          <td [class]="GetAreaClass(results.GetAreaState(Area.hipLeft))">Left {{ results.GetAreaState(Area.hipLeft) }}</td>  
          <td [class]="GetAreaClass(results.GetAreaState(Area.hipRight))">Right {{ results.GetAreaState(Area.hipRight) }}</td>     
        </tr>
        <tr>
          <td>Knees</td>
          <td [class]="GetAreaClass(results.GetAreaState(Area.kneeLeft))">Left {{ results.GetAreaState(Area.kneeLeft) }}</td>  
          <td [class]="GetAreaClass(results.GetAreaState(Area.kneeRight))">Right {{ results.GetAreaState(Area.kneeRight) }}</td>       
        </tr>
        <tr>
          <td>Ankles / Feet</td>
          <td [class]="GetAreaClass(results.GetAreaState(Area.ankleFootLeft))">Left {{ results.GetAreaState(Area.ankleFootLeft) }}</td>  
          <td [class]="GetAreaClass(results.GetAreaState(Area.ankleFootRight))">Right {{ results.GetAreaState(Area.ankleFootRight) }}</td>     
        </tr>
        <tr>
          <td>Big Toes</td>
          <td [class]="GetAreaClass(results.GetAreaState(Area.bigToeLeft))">Left {{ results.GetAreaState(Area.bigToeLeft) }}</td>  
          <td [class]="GetAreaClass(results.GetAreaState(Area.bigToeRight))">Right {{ results.GetAreaState(Area.bigToeRight) }}</td>       
        </tr>
      </tbody>
    </table>
</div>
